import { render } from "./quickstart.md?vue&type=template&id=30b7d663"
const script = {}
script.render = render

export default script